import React from 'react';
import { cn } from '@/utils/cn';
import { ADD_TO_CART } from '@/constants';
import { pageTypes } from '@/constants/types';
import Icon from '../Icon';
import ButtonLabel from '../Typography/ButtonLabel';

function AddToCartButton({
  label = ADD_TO_CART,
  className = '',
  color = '#FFFFFF',
  flexibleIconSize = true,
  hideIcon = false,
  disabled = false,
  pageType = pageTypes.categoricalProduct,
  productCount = 0,
  ...rest
}) {
  return (
    <button
      type="button"
      aria-label={label}
      className={cn(
        'w-[160px] lg:w-[200px] lg:h-[36px] rounded-[100px] flex justify-center items-center gap-2 bg-pacific-queen px-16 hover:bg-cape-verde border border-tealgreen',
        {
          'bg-disabled': disabled,
        },
        className,
        {
          'w-[124px] lg:w-[201px] h-[24px] lg:h-[36px]':
            pageType === pageTypes.categoricalProduct,
          'w-[160px] lg:w-[201px] h-[40px] lg:h-[36px]':
            pageType === pageTypes.productDetail,
          'w-[96px] lg:w-[160px] h-[24px] lg:h-[36px]':
            pageType === pageTypes.comparison,
          'w-[140px] lg:w-[164px] h-[24px] lg:h-[36px]':
            pageType === pageTypes.myOrder,
        },
      )}
      disabled={disabled}
      {...rest}
    >
      {!hideIcon ? (
        <Icon
          type="add-to-cart2"
          color={color}
          className={cn('size-[24px]', {
            'size-[14px] lg:size-[24px]': flexibleIconSize,
            'size-[16px] lg:size-[24px]': pageType === pageTypes.myOrder,
          })}
        />
      ) : null}

      <ButtonLabel
        label={label}
        className={cn(
          'lg:font-bold text-center whitespace-nowrap text-sm lg:text-sm text-white font-bold',
          {
            'text-pacific-queen': productCount > 0,
            'text-xs lg:text-sm text-left tracking-[0.24px] lg:tracking-[0.32px] whitespace-nowrap':
              pageType === pageTypes.categoricalProduct ||
              pageType === pageTypes.comparison ||
              pageType === pageTypes.myOrder,
          },
        )}
      />
    </button>
  );
}

export default AddToCartButton;
